import {concat, mergeDeepWith} from 'ramda';
import React, {useState} from 'react';
import {createRoot} from 'react-dom/client';

type Toastr = {
  success: (message: string) => void;
  error: (message: string) => void;
  warning: (message: string) => void;
  info: (message: string) => void;
};
let remoovToasterGlobal: Toastr;
const toastrDiv = document.createElement('div');
toastrDiv.id = 'toastr';
document.body.appendChild(toastrDiv);
const mountNode = document.getElementById('toastr');
if (!mountNode) throw new Error('Mount node not found!');
const root = createRoot(mountNode);
root.render(<ToastrComponent />);

// @ts-ignore
window.toastr = toastr;
export function toastr(): Toastr {
  return remoovToasterGlobal;
}
export type ToastrType = typeof toastr;
type Type = 'success' | 'error' | 'warning' | 'info';
type Message = {type: Type; text: string};
type State = {messages: Message[]};
function ToastrComponent() {
  const [state, setState] = useState<State>({messages: []});
  const addMessage = (type: Type) => (text: string) => {
    const message = {type, text};
    setState(mergeDeepWith(concat, {messages: [message]}));
    setTimeout(() => closeMessage(message), 5000);
  };
  const closeMessage = (message: Message) => {
    setState(({messages}) => ({
      ...state,
      messages: messages.filter(m => m !== message),
    }));
  };
  remoovToasterGlobal = {
    success: addMessage('success'),
    error: addMessage('error'),
    warning: addMessage('warning'),
    info: addMessage('info'),
  };
  return <StatelessToastr state={state} actions={{closeMessage}} />;
}
type Actions = {
  closeMessage: (message: Message) => unknown;
};
function StatelessToastr({state, actions}: {state: State; actions: Actions}) {
  const {messages} = state;
  return (
    <div style={{position: 'fixed', top: 30, right: 20, zIndex: 1000}}>
      {messages.map((message, index) => (
        <div
          key={index}
          style={{
            backgroundColor: typeToBackgroundColor(message.type),
            width: 250,
            minHeight: 75,
            color: typeToColor(message.type),
            fontSize: 16,
            fontFamily: "'Avenir Next', Verdana, 'Helvetica Neue', sans-serif",
            textAlign: 'center',
            borderRadius: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px',
          }}
          onClick={() => actions.closeMessage(message)}
        >
          {message.text}
        </div>
      ))}
    </div>
  );
}
function typeToBackgroundColor(type: Type): string {
  return {
    success: '#06D6A0',
    error: '#FF331F',
    warning: '#FFD166',
    info: '#86BBD8',
  }[type];
}
function typeToColor(type: Type): string {
  return {
    success: 'white',
    error: 'white',
    warning: '#2E3192',
    info: 'white',
  }[type];
}
